<template>
	<div>
		<div class="text-gray-500" v-if="!open">
			<div class="font-medium invisible select-none" v-if="labelSpacer">placeholder</div>
			<div class="mt-1 flex items-center pb-2 mb-px">
				{{
					$cropOptions.getLocalizedLabel(
						form.qty.tolerance,
						$cropOptions.qtyToleranceOptions
					)
				}}
				{{ __("Tolerance") }}
				<ui-tooltip
					class="text-green-400"
					:icon-stroke-width="2"
					icon-class="ml-1 w-4 h-4"
					:text="
						__(
							'The tolerance is the percentage quantity that may be over or under delivered at the contract price.'
						)
					"
				/>
				<ui-button
					class="hover:bg-gray-100 rounded-lg p-2 text-orange-500"
					v-on:click="open = true"
					type="blank"
				>
					<ui-icon name="edit-2" class="text-orange h-6 w-6" stroke-width="2" />
				</ui-button>
			</div>
		</div>
		<ui-select-group
			v-else
			v-model="form.qty.tolerance"
			field="qty.tolerance"
			label="Tolerance"
			:form="form"
			:required="true"
			:options="$cropOptions.qtyToleranceOptions"
		/>
	</div>
</template>

<script>
export default {
	props: {
		form: {
			type: Object,
			required: true,
		},
		labelSpacer: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			open: false,
		};
	},
};
</script>
